import { render, staticRenderFns } from "./DeleteConfirmRedem.vue?vue&type=template&id=fc5b2298&"
import script from "./DeleteConfirmRedem.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmRedem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports